import { gql } from '@apollo/client';

// Generate OTP mutation
export const GENERATE_OTP = gql`
  mutation GenerateOTP($userId: String!, $event: String!, $channel: String!) {
    generateOtp(userId: $userId, event: $event, channel: $channel) {
      success
      message
      expirySecond
      __typename
    }
  }
`;

// Verify OTP mutation
export const VERIFY_OTP = gql`
  mutation VerifyOTP($userId: String!, $otpCode: String!, $event: String!) {
    verifyOtp(userId: $userId, otpCode: $otpCode, event: $event) {
      success
      message
      __typename
    }
  }
`;

// Resend OTP mutation
export const RESEND_OTP = gql`
  mutation ResendOTP($userId: String!, $event: String!, $channel: String!) {
    resendOtp(userId: $userId, event: $event, channel: $channel) {
      success
      message
      expirySecond
      __typename
    }
  }
`;

// Types for OTP operations
export interface GenerateOtpVariables {
  userId: string;
  event: string;
  channel: string;
}

export interface VerifyOtpVariables {
  userId: string;
  otpCode: string;
  event: string;
}

export interface ResendOtpVariables {
  userId: string;
  event: string;
  channel: string;
}

export interface OtpResponse {
  success: boolean;
  message: string;
  expirySecond?: number;
  __typename?: string;
}